import { Icon } from "react-migration/components/Icon";
import { Button } from "react-migration/components/Button";

export type SimplePaginationProps = {
  page: number;
  totalPages: number;
  onPreviousPage: () => void;
  onNextPage: () => void;
  disabled?: boolean;
};

export const SimplePagination = ({ page, totalPages, onPreviousPage, onNextPage, disabled }: SimplePaginationProps) => {
  const isFirstPage = page === 1;
  const isLastPage = page === totalPages;

  return (
    <div className="flex items-center select-none gap-x-1 h-9" data-testid="simple-pagination">
      <Button variant="ghost" onClick={onPreviousPage} disabled={disabled || isFirstPage} className="w-9">
        <Icon size="md" icon="icon-lt-arrow-left-s-line" extraClasses="pointer-events-none" />
      </Button>
      <span className="text-sm text-blue-grey-950">
        {page}/{totalPages}
      </span>
      <Button variant="ghost" onClick={onNextPage} disabled={disabled || isLastPage} className="w-9">
        <Icon size="md" icon="icon-lt-arrow-right-s-line" extraClasses="pointer-events-none" />
      </Button>
    </div>
  );
};
